/** Кружок цвета на плитке/в модалке витрины пультов (Белый / Чёрный и т.д.). */
export function isBlackAccessoryColorLabel(label: string | null | undefined): boolean {
  const n = (label || '')
    .trim()
    .toLowerCase()
    .replace(/ё/g, 'е')
  return (
    n.includes('черн') ||
    n.includes('black') ||
    n === 'ч' ||
    n.startsWith('ч ')
  )
}

export function accessoryColorSwatchClass(label: string | null | undefined): string {
  if (isBlackAccessoryColorLabel(label)) {
    return 'bg-gray-900 border-gray-600'
  }
  const n = (label || '').trim().toLowerCase().replace(/ё/g, 'е')
  if (n.includes('сереб') || n.includes('silver') || n.includes('сер')) {
    return 'bg-gray-300 border-gray-400'
  }
  return 'bg-white border-gray-300'
}
